import * as React from "react";
const SvgBarchart = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: 24, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 5e3, height: 24, fill: "currentColor" }));
export default SvgBarchart;
